import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "nav" }
const _hoisted_6 = { class: "main-content" }
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = { class: "footer-main" }
const _hoisted_9 = { class: "footer-section footer-brand" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "footer-section footer-contact" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo-link"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.logoUrl,
              alt: "ПСК МОНТАЖ",
              class: "logo"
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }),
        _createElementVNode("nav", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/about",
            class: "nav-link"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("О компании", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/products",
            class: "nav-link"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Продукция", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/catalog",
            class: "nav-link"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Каталог", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/certificates",
            class: "nav-link"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Сертификаты", -1)
            ]))]),
            _: 1
          }),
          (_ctx.hasVacancies)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/vacancies",
                class: "nav-link"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Вакансии", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: "/contacts",
            class: "nav-link"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Контакты", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("footer", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "footer-logo-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.logoUrl,
                alt: "ПСК МОНТАЖ",
                class: "footer-logo"
              }, null, 8, _hoisted_10)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "footer-company" }, "Завод стальных дверей «ПСК Монтаж»", -1)),
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: "tel:+79180301137",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackPhone('89180301137')))
            }, "8 (918) 030-11-37"),
            _cache[8] || (_cache[8] = _createTextVNode(", ", -1)),
            _createElementVNode("a", {
              href: "tel:+79627667256",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackPhone('89627667256')))
            }, "8 (962) 766-72-56")
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("p", null, [
            _createElementVNode("a", { href: "mailto:PSKMontag23@yandex.ru" }, "PSKMontag23@yandex.ru")
          ], -1))
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "footer-bottom" }, [
        _createElementVNode("div", { class: "footer-bottom-links" }, [
          _createElementVNode("a", { href: "#" }, "Условия использования сайта"),
          _createElementVNode("a", { href: "#" }, "Политика конфиденциальности")
        ])
      ], -1))
    ])
  ]))
}